import React, { useState, useCallback } from 'react';
import DownChevron from 'src/assets/icons/DownChevron';
import CustomPopover, { useCustomPopover } from './Popover/CustomPopover';
import RadioButton from 'src/components/Actions/radioButton';
import { useLocation } from 'react-router-dom';

const DropDownAms = () => {

  const selectedProfileId = JSON.parse(sessionStorage.getItem('selectedProfileId'));
  const selectedGroupProfileId = JSON.parse(sessionStorage.getItem('selectedGroupedProfileId'));
  const localProfileId = selectedProfileId?.ams?.groupedAccounts || [];

  return (
    <div>
      <CustomPopover
        buttonTrigger={
          <div className='d-flex align-items-center justify-content-between Update-Audience-dropdown gap-10'>
            <span className='Update-Audience-dropdown-btn f-w-500'>
             Ad Account - {selectedGroupProfileId?.accountInfo?.sortName ? selectedGroupProfileId?.accountInfo?.sortName : selectedGroupProfileId?.accountInfo?.name}
            </span>
            <DownChevron style={{ width: '10px', height: '10px' }} />
          </div>
        }
        popoverContent={
          <DropdownAMSContent selectedProfileId={selectedProfileId} localProfileId={localProfileId} selectedGroupProfileId={selectedGroupProfileId} />
        }
        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
        transformOrigin={{ vertical: 'top', horizontal: 'left' }}
      />
    </div>
  );
};

const DropdownAMSContent = ({ selectedProfileId, localProfileId, selectedGroupProfileId }) => {

  const [selected, setSelected] = useState(selectedGroupProfileId);
  const location = useLocation()
  const { handleClose = () => { } } = useCustomPopover()

  const handleSelection = (selectedItem) => {
    setSelected(selectedItem);
  };

  const handleApply = useCallback(async () => {
    sessionStorage.setItem('selectedGroupedProfileId', JSON.stringify(selected));
    window.location.assign(location.pathname)
  }, [selected, location.pathname]);

  return (
    <div className="Update-Audience-dropdown-list">
      <li key={selectedProfileId?.profileId} className='Update-Audience-dropdown-item'>
        <div className='d-flex align-items-center gap-2 Update-Audience-dropdown-container'>
          <RadioButton
            radioSize={'15px'}
            title={<span className='f-12'>{selectedProfileId?.accountInfo?.sortName ? selectedProfileId?.accountInfo?.sortName : selectedProfileId?.accountInfo?.name}</span>}
            checked={selected?.profileId === selectedProfileId?.profileId}
            action={() => handleSelection(selectedProfileId)}
          />
        </div>
      </li>
      {localProfileId.map(item => {
        return (
          <li key={item.profileId} className='Update-Audience-dropdown-item'>
            <div className='d-flex align-items-center gap-2 Update-Audience-dropdown-container'>
              <RadioButton
                classes={'Update-Audience-dropdown-radio'}
                radioSize={'15px'}
                title={<span className='f-12' style={{ fontWeight: '500 !important' }}>{item?.accountInfo?.sortName ? item?.accountInfo?.sortName : item?.accountInfo?.name}</span>}
                checked={selected?.profileId === item?.profileId}
                action={() => handleSelection(item)}
              />
            </div>
          </li>
        )
      })}
      <div className='update-audience-btn-container'>
        <button
          className='cls-btn cursor-pointer rounded-4 f-10 py-2 px-3 f-w-600 f-202226'
          onClick={() => {
            handleClose()
          }}
        >
          Cancel
        </button>
        <button
          className={`bg-blue ${selected?.profileId == selectedGroupProfileId?.profileId ? 'disabled' : ''} rounded-4 f-10 py-2 px-3 f-w-600 cursor-pointer text-white mt-0 ml-2`}
          onClick={handleApply}
        >
          Apply
        </button>
      </div>
    </div>
  )
}

export default DropDownAms;
